var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomModule9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89998 4.89998V19.1H12.9008C12.9008 19.9999 12.89 20.7725 12.9008 20.9H4.99998C4.49606 20.9 4.01279 20.6998 3.65647 20.3435C3.30015 19.9872 3.09998 19.5039 3.09998 19V4.99998C3.09998 3.9452 3.9452 3.09998 4.99998 3.09998H14.9586L20.9 9.0414L20.8997 12.9H19.1V11.9H12.1V4.89998H4.89998ZM19.7414 10.1L13.9 4.25855V10.1H19.7414Z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 19.5714L21.3328 15.9886L22.3651 17.2434L17.7531 21.8554L15.1384 19.003L16.16 17.9814L17.75 19.5714Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModule9);
export default __webpack_public_path__ + "static/media/CustomModule9.1e1b555f367b4b726a47fb9c15b7009f.svg";
export { ForwardRef as ReactComponent };